let language = {
    "STORE_EMAIL_SETTING_TITLE": "发货邮件设置",
    "STORE_EMAIL_SETTING_DESP": "通过电子邮件自动向客户发送快递单号。",
    "STORE_EMAIL_SETTING_NOTIFY_TYPE1": "禁用",
    "STORE_EMAIL_SETTING_NOTIFY_TYPE2": "通过{{appName}}的邮件服务器发送邮件",
    "STORE_EMAIL_SETTING_NOTIFY_TYPE3": "通过我自己的邮件服务器发送邮件",
    "STORE_EMAIL_SETTING_FORM_EMAIL_ADDRESS_LABEL": "电子邮件地址:",
    "STORE_EMAIL_SETTING_FORM_PASSWORD_LABEL": "电子邮件密码:",
    "STORE_EMAIL_SETTING_FORM_SMTP_SERVER_LABEL": "SMTP服务器:",
    "STORE_EMAIL_SETTING_FORM_SMTP_PORT_LABEL": "SMTP端口:",
    "STORE_EMAIL_SETTING_FORM_SMTP_SSL_LABEL": "SSL",
    "STORE_EMAIL_SETTING_TEST_SEND_BTN": "测试",
    "STORE_EMAIL_SETTING_SAVE_BTN": "保存",
    "STORE_EMAIL_SETTING_SEND_SUCCESS": "发送成功",
    "STORE_EMAIL_SETTING_SAVE_SUCCESS": "保存成功",
    "STORE_EMAIL_SETTING_SAVE_CONFIRM_TITLE": "发货邮件设置",
    "STORE_EMAIL_SETTING_SAVE_CONFIRM_CONTENT": "在保存之前，请仔细检查您的邮件服务器详细信息是否正确。",
    // send-email-modal
    "SEND_EMAIL_RECEIVE_MAIL_HEADER_TITLE": "邮件服务器测试",
    "SEND_EMAIL_RECEIVE_MAIL_CONTENT": "输入您的电子邮件地址以接收测试发货确认。我们将向您发送一封测试发货电子邮件，以验证您的商店邮件设置。这可能需要几分钟。",
    "SEND_EMAIL_ADDRESS_EMPTY_TIP": "不能为空！",
    "SEND_EMAIL_ADDRESS_INCORRECT_FORMAT_TIP": "电子邮件格式不正确",
    "SEND_EMAIL_ADDRESS_CANCEL_BTN": "取消",
    "SEND_EMAIL_ADDRESS_SEND_BTN": "发送",
    "SEND_EMAIL_ADDRESS_PLEASE_ENTER_A_VALID": "请输入有效的电子邮件地址",
};

export { language }
